var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDrayageContainerCircleGreenFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#16AA65"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2311 15.8823H13.3648L18.2977 12.008L23.2311 15.8823ZM11.9797 17.9312H12.9657V23.7405H11.9797V17.9312ZM14.2959 17.9312H15.2819V23.7405H14.2959V17.9312ZM16.6133 17.9312H17.5993V23.7405H16.6133V17.9312ZM18.9303 17.9312H19.9163V23.7405H18.9303V17.9312ZM23.5643 17.9312H24.5503V23.7405H23.5643V17.9312ZM9.59755 25.7894H27.0002V15.8823H25.0378L19.398 11.4532C19.6105 11.2269 19.751 10.9318 19.7807 10.5951L18.6721 10.4992C18.6557 10.6881 18.4821 10.8065 18.3016 10.8057C18.0963 10.8046 17.928 10.6378 17.928 10.4318C17.928 10.2288 18.089 10.0604 18.2932 10.0582L18.8454 10.0517V8.63574H19.203V6.74756H17.3704V8.63574H17.7276V9.05923C17.175 9.29002 16.8106 9.83004 16.8106 10.4321C16.8106 10.8244 16.9614 11.1797 17.2082 11.4452L11.5581 15.8823H9.59717L9.59831 20.8354L9.59755 25.7894ZM21.2469 17.9312H22.2329V23.7405H21.2469V17.9312Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrayageContainerCircleGreenFilled);
export default __webpack_public_path__ + "static/media/drayage-container-circle-green-filled.3ffe9055.svg";
export { ForwardRef as ReactComponent };